import React from "react";
import { connect } from "react-redux";
import Drawer from 'devextreme-react/drawer';
import Toolbar, { Item } from "devextreme-react/toolbar";
import List from "devextreme-react/list";
import notify from 'devextreme/ui/notify';
import ArrayStore from "devextreme/data/array_store";
import { ABECASUSER_LOGIN_TYPE } from "../../../../common/permissions";
import Popup from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";
import FormField from "../../../../dynamicFormBuilder/FormField";
import { IDCarrierLookupLayout } from "../../../../common/lookups/Layouts/IdLayouts";
import UpdateStageGridPreview from "../commitTransactions/WMTransactionsGridPreview";
import UpdateStagePrintErrors from "../commitTransactions/WMTransactionsPrintErrors";
import { Button } from 'devextreme-react/button';
import DataGrid, { Column, Editing, Lookup } from "devextreme-react/data-grid";
import Accordion from 'devextreme-react/accordion';
import axios from "axios";
import routes from "../../../../assets/apiRoutes.json";
import { LoadPanel } from 'devextreme-react/load-panel';

// Print Errors shows the error rows returned by the Start response (state.ABErros); it no longer re-reads
// ABErrorsHeader by SourceForm, because the proc truncates that table on every per-row call.
const REPORT_NAME = "WMUpdateTransactionStage";
const TABLE = "WMTRANSACTIONHEADER";

// Stage / Status / Trans Type option labels are NOT hand-kept here — they ride the report response as
// WhereInfo.Items (the backend flag dictionary is the single authority for the labels) and are built from
// it in populateFlagSelects(). The lists below are UI-only, with no backend copy to drift against.
// Proc generates serials when @inGenSerialNo = 0, so code 0 = Yes (generate), code 1 = No (suppress)
// — matching legacy edtGenSerialNo (Items = Yes/No, index 0 = Yes). Default stays '1' (= No).
const GEN_SERIAL_OPTIONS = [{ code: "0", name: "Yes" }, { code: "1", name: "No" }];
const EXECUTE_OPTIONS = [{ code: "Now", name: "Now" }, { code: "Delayed", name: "Delayed" }];
const DELAY_OPTIONS = [
  { code: "0", name: "None" }, { code: "250", name: "250 ms" }, { code: "500", name: "500 ms" }, { code: "1000", name: "1000 ms" },
];
const SELECT_TOP_OPTIONS = [
  { code: "0", name: "None" }, { code: "300", name: "Top 300" }, { code: "700", name: "Top 700" }, { code: "1000", name: "Top 1000" },
];

const STAGE_COMPLETED = "C";
const STATUS_READY_LATER = "L";
const STATUS_OPEN = "O";
const TYPE_ADJUSTMENTS = "A";

// Static option schema for the dynamic form — the three Delphi WMD0076 sections.
const OPTIONS_SCHEMA = [
  {
    groupId: 1,
    label: "Default Values",
    fields: [
      { name: "ToStage", tableName: TABLE, label: "To Stage", type: "select", required: true, visible: true, isLabelChanged: true },
      { name: "ToStatus", tableName: TABLE, label: "To Status", type: "select", required: true, visible: true, isLabelChanged: true },
      { name: "RecvShipDate", tableName: TABLE, label: "Recv/Ship", type: "datetime", visible: true, isLabelChanged: true },
      { name: "ForceRecShipDate", tableName: TABLE, label: "Force Receipt/Ship Date", type: "checkbox", visible: true, isLabelChanged: true },
      { name: "Carrier", tableName: TABLE, label: "Carrier ID", type: "lookup", layout: IDCarrierLookupLayout, visible: true, isLabelChanged: true },
      { name: "Reference4", tableName: TABLE, label: "Reference 4", type: "text", visible: true, isLabelChanged: true },
      { name: "Reference5", tableName: TABLE, label: "Reference 5", type: "text", visible: true, isLabelChanged: true },
      { name: "UserDefinedDate1", tableName: TABLE, label: "Date 1", type: "date", visible: true, isLabelChanged: true },
      { name: "UserDefinedDate7", tableName: TABLE, label: "Date 7", type: "date", visible: true, isLabelChanged: true },
    ],
  },
  {
    groupId: 2,
    label: "Filters",
    fields: [
      { name: "TransactionType", tableName: TABLE, label: "Trans Type", type: "select", required: true, visible: true, isLabelChanged: true },
      { name: "GenSerialNo", tableName: TABLE, label: "Gen Serial#", type: "select", visible: true, isLabelChanged: true },
      { name: "TransactionStage", tableName: TABLE, label: "Tran. Stag", type: "select", visible: true, isLabelChanged: true },
    ],
  },
  {
    groupId: 3,
    label: "Delayed Execution",
    fields: [
      { name: "ExecuteType", tableName: TABLE, label: "Execute Type", type: "select", visible: true, isLabelChanged: true },
      { name: "DelayMs", tableName: TABLE, label: "Delay time", type: "select", visible: true, isLabelChanged: true },
      { name: "SelectTop", tableName: TABLE, label: "Select top", type: "select", visible: true, isLabelChanged: true },
    ],
  },
];

const initialFormFields = () => ({
  // Default Values
  ToStage: "C",
  ToStatus: "L",
  RecvShipDate: new Date(),
  ForceRecShipDate: false,
  Carrier: "",
  Reference4: "",
  Reference5: "",
  UserDefinedDate1: null,
  UserDefinedDate7: null,
  // Filters
  TransactionType: "B",
  GenSerialNo: "1",
  TransactionStage: "",
  // Delayed Execution
  ExecuteType: "Now",
  DelayMs: "0",
  SelectTop: "0",
});

const searchpanel = [{ ID: 1, Name: 'Options' }];
const list = React.createRef();
const dataGrid = React.createRef();
let ignoreListSelectionChange = false;

const orderByDataSource = new ArrayStore({ data: [{ ID: 0, Text: "None" }, { ID: 1, Text: "Ascending" }, { ID: 2, Text: "Descending" }], key: "ID" });
const prefixDataSource = new ArrayStore({ data: [{ ID: 0, Text: "And" }, { ID: 1, Text: "Or" }], key: "ID" });
const groupDataSource = new ArrayStore({ data: [{ ID: 0, Text: "No" }, { ID: 1, Text: "Begin" }, { ID: 2, Text: "End" }], key: "ID" });
const operationDataSource = new ArrayStore({
  data: [
    { ID: 0, Text: "StartsWith" }, { ID: 1, Text: "EndsWith" }, { ID: 2, Text: "Contains" },
    { ID: 3, Text: "Equal" }, { ID: 4, Text: "NotEqual" }, { ID: 5, Text: "Greater" },
    { ID: 6, Text: "GreaterEqual" }, { ID: 7, Text: "Less" }, { ID: 8, Text: "LessEqual" },
    { ID: 9, Text: "Between" }, { ID: 10, Text: "Includes" },
  ], key: "ID"
});

let accessToken = "";
class UpdateTransactionsStage extends React.Component {
  constructor(props) {
    super(props);
    accessToken = props.oidc.user.access_token;
    this.currentUser = props.oidc.user;
    this.dynamicFormSetting = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    // Plain formRefs container (FormField sets formRefs.current[fieldName]).
    this.formRefs = { current: {} };
    this.startButtonClicked = this.startButtonClicked.bind(this);
    this.previewButtonClicked = this.previewButtonClicked.bind(this);
    this.resetButtonClicked = this.resetButtonClicked.bind(this);
    this.printErrorsButtonClicked = this.printErrorsButtonClicked.bind(this);
    this.selectionChanged = this.selectionChanged.bind(this);
    this.loadFields = this.loadFields.bind(this);
    this.dataFieldSelectionChanged = this.dataFieldSelectionChanged.bind(this);
    this.dataFieldRender = this.dataFieldRender.bind(this);
    this.setFormFields = this.setFormFields.bind(this);
    this.setSelectOptions = this.setSelectOptions.bind(this);
    this.handleFormLoad = this.handleFormLoad.bind(this);
    this.handleFieldValueChange = this.handleFieldValueChange.bind(this);
    this.flagOptions = this.flagOptions.bind(this);
    this.statusOptions = this.statusOptions.bind(this);
    this.populateFlagSelects = this.populateFlagSelects.bind(this);
    this.state = this.getInitialState(props);
    this.toolbarItems = [{
      widget: 'dxButton', location: 'right',
      options: { icon: 'menu', onClick: () => this.setState({ opened: !this.state.opened }) },
    }];
    this.loadFields();
  }

  getInitialState(props) {
    return {
      animationDuration: 300,
      selectedItems: [],
      loadIndicatorVisible: false,
      isPreviewGridPopupVisible: false,
      isPrintPreviewPopupVisible: false,
      ABErros: [],
      previewData: [],
      opened: (props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE),
      report: { parameterList: [], queryParameters: [], whereInfoList: [], filterWhereInfoList: [] },
      formFields: initialFormFields(),
    };
  }

  // Adapter so FormField's setformFields(prev => ...) functional updater works from a class.
  setFormFields(updater) {
    this.setState((prev) => ({
      formFields: typeof updater === "function" ? updater(prev.formFields) : updater,
    }));
  }

  // Set a select's dataSource/value via its formRef instance (rule 3 pattern).
  setSelectOptions(name, options, value) {
    const ref = this.formRefs.current?.[name];
    if (ref && typeof ref.instance === "function") {
      const inst = ref.instance();
      inst.option("dataSource", options);
      inst.option("valueExpr", "code");
      inst.option("displayExpr", "name");
      if (value !== undefined && value !== null) inst.option("value", value);
    }
  }

  // Build a code/label option list from the report's WhereInfo.Items for a flag field — the backend flag
  // dictionary is the single authority for the labels. `report` lets callers pass the freshly-fetched
  // response before setState has applied.
  flagOptions(fieldName, report) {
    const rep = report || this.state.report;
    const wi = (rep.whereInfoList || []).find((w) => w.fieldName === fieldName);
    return (wi && wi.items ? wi.items : []).map((it) => ({ code: it.value, name: it.text }));
  }

  // "To Status" list — "Ready To Commit Later" only when the stage is Completed.
  statusOptions(includeReadyLater, report) {
    const all = this.flagOptions("Status", report);
    return includeReadyLater ? all : all.filter((o) => o.code !== STATUS_READY_LATER);
  }

  // Populate the Stage / Status / Trans Type selects from the report response (called on form load and
  // whenever the report arrives, so ordering of the two async paths doesn't matter).
  populateFlagSelects(report) {
    const ff = this.state.formFields;
    this.setSelectOptions("ToStage", this.flagOptions("Stage", report), ff.ToStage);
    this.setSelectOptions("ToStatus", this.statusOptions(ff.ToStage === STAGE_COMPLETED, report), ff.ToStatus);
    this.setSelectOptions("TransactionType", this.flagOptions("TransactionType", report), ff.TransactionType);
  }

  // Load all dropdown options once the form widgets exist (rule 3).
  handleFormLoad() {
    const ff = this.state.formFields;
    this.populateFlagSelects();
    this.setSelectOptions("GenSerialNo", GEN_SERIAL_OPTIONS, ff.GenSerialNo);
    this.setSelectOptions("ExecuteType", EXECUTE_OPTIONS, ff.ExecuteType);
    this.setSelectOptions("DelayMs", DELAY_OPTIONS, ff.DelayMs);
    this.setSelectOptions("SelectTop", SELECT_TOP_OPTIONS, ff.SelectTop);
    // "Tran. Stag" crates list from the backend (SPWM_USERDEFINEDGENERATECRATES).
    axios.get(`${window._env_.REACT_APP_APIS}/${routes.Transaction.GetTransactionStageOptions}`,
      { headers: { access_token: accessToken, Authorization: `Bearer ${accessToken}` } })
      .then((res) => {
        const opts = (res.data || []).map((o) => ({ code: o.value, name: o.text }));
        this.setSelectOptions("TransactionStage", opts.length ? opts : [{ code: "", name: "None" }], ff.TransactionStage);
      })
      .catch((err) => {
        this.setSelectOptions("TransactionStage", [{ code: "", name: "None" }], ff.TransactionStage);
        console.log(err, "Error loading Tran. Stag options");
      });
  }

  // Interactive business rules (Delphi edtToStageChange / edtToStatusChange / AdjustmentCheck /
  // edtExecuteChange).
  handleFieldValueChange(name, value) {
    const ff = this.state.formFields;
    if (name === "ToStage") {
      const completed = value === STAGE_COMPLETED;
      // "Ready To Commit Later" is only offered when the stage is Completed.
      this.setSelectOptions("ToStatus", this.statusOptions(completed));
      if (!completed && ff.ToStatus === STATUS_READY_LATER) {
        this.setFormFields((prev) => ({ ...prev, ToStatus: STATUS_OPEN }));
        this.setSelectOptions("ToStatus", this.statusOptions(false), STATUS_OPEN);
        notify({ message: "Status cannot be Ready To Commit Later unless Stage is set to Completed — Status set to Open.", width: 500 }, "warning", 4000);
      }
      if (!completed && ff.TransactionType === TYPE_ADJUSTMENTS) {
        notify({ message: "Stage must be set to Completed/Loaded/Put Away/Transferred/Adjusted, before Adjustment transactions can be updated.", width: 540 }, "warning", 5000);
      }
    } else if (name === "TransactionType") {
      if (value === TYPE_ADJUSTMENTS && ff.ToStage !== STAGE_COMPLETED) {
        notify({ message: "Stage must be set to Completed/Loaded/Put Away/Transferred/Adjusted, before Adjustment transactions can be updated.", width: 540 }, "warning", 5000);
      }
    } else if (name === "ExecuteType") {
      // Delay time / Select top only apply to delayed execution — reset them for "Now".
      if (value !== "Delayed") {
        this.setFormFields((prev) => ({ ...prev, DelayMs: "0", SelectTop: "0" }));
        this.setSelectOptions("DelayMs", DELAY_OPTIONS, "0");
        this.setSelectOptions("SelectTop", SELECT_TOP_OPTIONS, "0");
      }
    }
  }

  startButtonClicked = async (e) => {
    e.event.stopPropagation();
    this.setState({ loadIndicatorVisible: true });
    try {
      const payload = { filterWhereInfoList: this.state.report.filterWhereInfoList, ...this.state.formFields };
      const res = await axios.post(
        `${window._env_.REACT_APP_APIS}/${routes.Transaction.UpdateTransactionStage}`,
        JSON.stringify(payload),
        { headers: { "Content-Type": "application/json", access_token: accessToken, Authorization: `Bearer ${accessToken}` } }
      );
      notify({ message: res.data.message, width: 500 }, (res.data.success ? 'success' : 'error'), 5000);
      // Errors are captured server-side during the run and returned here. The proc truncates ABErrorsHeader
      // on every (per-row) call, so we can't re-read the table afterwards for batched runs — keep this set.
      this.setState({ ABErros: res.data?.resultdata?.errors ?? [] });
    } catch (error) {
      notify({ message: 'Update Stage Failed Due To Data Errors - Use Print Errors Button To View Report', width: 450 }, 'error', 3000);
      console.error('Error updating transaction stage.', error);
    } finally {
      this.setState({ loadIndicatorVisible: false });
    }
  }

  previewButtonClicked = async (e) => {
    e.event.stopPropagation();
    this.setState({ loadIndicatorVisible: true });
    try {
      const payload = { filterWhereInfoList: this.state.report.filterWhereInfoList, TransactionType: this.state.formFields.TransactionType };
      const res = await axios.post(
        `${window._env_.REACT_APP_APIS}/${routes.Transaction.GetUpdateStageRecords}`,
        JSON.stringify(payload),
        { headers: { "Content-Type": "application/json", access_token: accessToken, Authorization: `Bearer ${accessToken}` } }
      );
      this.setState({ previewData: res.data, isPreviewGridPopupVisible: true });
    } catch (error) {
      console.error('Error getting preview data:', error);
    } finally {
      this.setState({ loadIndicatorVisible: false });
    }
  }

  resetButtonClicked(e) {
    e.event.stopPropagation();
    this.formRefs = { current: {} };
    this.setState(this.getInitialState(this.props), () => this.loadFields());
  }

  printErrorsButtonClicked = (e) => {
    e.event.stopPropagation();
    // Show the errors captured from the last Start run. We deliberately don't re-read ABErrorsHeader here:
    // the proc truncates that table on every per-row call, so a fresh DB read would miss all but the last
    // row's errors on a batched run. this.state.ABErros holds the full set returned by the Start response.
    this.setState({ isPrintPreviewPopupVisible: true });
  }

  selectionChanged(e) {
    let newItems = [...this.state.selectedItems];
    e.removedItems.forEach((item) => { const i = newItems.indexOf(item); if (i >= 0) newItems.splice(i, 1); });
    if (e.addedItems.length) newItems = [...newItems, ...e.addedItems];
    this.setState({ selectedItems: newItems });
  }

  dataFieldRender(e) {
    const dataSource = dataGrid.current.instance().getDataSource();
    if (dataSource != null && dataSource._items != null) {
      const found = dataSource._items.find(i => i.origin == e.itemData.origin);
      if (found != null && !e.component.isItemSelected(e.itemIndex)) {
        ignoreListSelectionChange = true;
        e.component.selectItem(e.itemIndex);
        ignoreListSelectionChange = false;
      }
    }
  }

  dataFieldSelectionChanged(e) {
    if (ignoreListSelectionChange) return;
    if (e.addedItems != null && e.addedItems.length === 1) {
      const dataSource = dataGrid.current.instance().getDataSource();
      dataSource.store().insert(e.addedItems[0]).done(() => dataSource.reload()).fail((err) => alert(err));
    }
    if (e.removedItems != null && e.removedItems.length === 1) {
      const dataSource = dataGrid.current.instance().getDataSource();
      dataSource.store().remove(e.removedItems[0].displayLabel).done(() => dataSource.reload()).fail((err) => alert(err));
    }
  }

  loadFields() {
    const that = this;
    axios
      .get(`${window._env_.REACT_APP_APIS}/${routes.reports.GetReport}?reportName=${REPORT_NAME}`,
        { headers: { "Content-Type": "application/json", access_token: accessToken, Authorization: `Bearer ${accessToken}` } })
      .then((res) => {
        // Flag fields carry from/to as codes → show their labels (mirrors the commit screen).
        [res.data.filterWhereInfoList, res.data.whereInfoList].forEach((listData) => {
          for (let i = 0; listData != null && i < listData.length; i++) {
            if (listData[i].fieldType === 5 && listData[i].items != null) {
              for (let j = 0; j < listData[i].items.length; j++) {
                if (listData[i].from == listData[i].items[j].value) listData[i].from = listData[i].items[j].text;
                if (listData[i].to == listData[i].items[j].value) listData[i].to = listData[i].items[j].text;
              }
            }
          }
        });

        that.setState({ report: res.data });
        // The report response is the single source for the Stage / Status / Trans Type dropdown labels.
        that.populateFlagSelects(res.data);

        const dataFilterDataSource = new ArrayStore({ data: that.state.report.filterWhereInfoList, key: "displayLabel" });
        dataGrid.current.instance().option("dataSource", dataFilterDataSource);

        ignoreListSelectionChange = true;
        for (let i = 0; res.data.whereInfoList != null && i < res.data.whereInfoList.length; i++) {
          for (let j = 0; res.data.filterWhereInfoList != null && j < res.data.filterWhereInfoList.length; j++) {
            if (res.data.whereInfoList[i].origin == res.data.filterWhereInfoList[j].origin) {
              if (!list.current.instance().isItemSelected(i)) list.current.instance().selectItem(i);
              break;
            }
          }
        }
        ignoreListSelectionChange = false;
      })
      .catch((err) => console.log(err, "Error getting update-stage fields"));
  }

  render() {
    return (
      <>
        <div>
          <div className="row">
            <div className="col-md-12 main-page">
              <div id="accordion">
                <Accordion
                  dataSource={searchpanel}
                  collapsible={true}
                  multiple={false}
                  animationDuration={this.state.animationDuration}
                  selectedItems={this.state.selectedItems}
                  onSelectionChanged={this.selectionChanged}
                  itemTitleRender={() => (
                    <Toolbar className="accordian-toolbar">
                      <Item location="before">
                        <div className="title">
                          <h6 style={{ color: window._env_.Color2 }}>Update Transaction Stage</h6>
                        </div>
                      </Item>
                      <Item location="after">
                        <Button className="accordianButton" text="Start" onClick={(e) => this.startButtonClicked(e)} type="default" />
                      </Item>
                      <Item location="after">
                        <Button className="accordianButton" onClick={(e) => this.previewButtonClicked(e)} text="Preview" />
                      </Item>
                      <Item location="after">
                        <Button className="accordianButton" onClick={(e) => this.resetButtonClicked(e)} text="Reset" />
                      </Item>
                      <Item location="after">
                        <Button className="accordianButton" onClick={(e) => this.printErrorsButtonClicked(e)} text="Print Errors" />
                      </Item>
                    </Toolbar>
                  )}
                  itemRender={() => (
                    <div className="row">
                      <div className="col-md-12">
                        <FormField
                          currrentUser={this.currentUser}
                          layoutId="7C1E9A4B-2D38-4F60-9B71-5A2C8E6D3F14"
                          layoutName="WMUpdateTransactionStageForm"
                          defaultFormSchema={OPTIONS_SCHEMA}
                          formFields={this.state.formFields}
                          setformFields={this.setFormFields}
                          handleFieldValueChange={this.handleFieldValueChange}
                          DYNAMICFORMSETTING={this.dynamicFormSetting}
                          formRefs={this.formRefs}
                          onFormLoad={this.handleFormLoad}
                          noSpacingBeforeFirstRow={true}
                        />
                      </div>
                    </div>
                  )}
                  id="accordion-container" className="accordion-height"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className={this.state.opened ? 'toolbar-holder' : 'toolbar-holder collapse-drawer '}>
            <Toolbar items={this.toolbarItems} />
          </div>
        </div>
        <div className="row bg-white">
          <div>
            <LoadPanel
              shadingColor="rgba(0,0,0,0.4)"
              onHiding={() => this.setState({ loadIndicatorVisible: false })}
              visible={this.state.loadIndicatorVisible}
              showIndicator={true} shading={true} showPane={true} hideOnOutsideClick={false}
            />
            <Drawer
              opened={this.state.opened}
              openedStateMode={'shrink'}
              position={'left'}
              revealMode={'slide'}
              render={() =>
                <List
                  ref={list}
                  dataSource={this.state.report.whereInfoList}
                  pageLoadMode="scrollBottom"
                  style={{ backgroundColor: '#F6F7FB' }}
                  displayExpr="displayLabel"
                  searchEnabled={true}
                  searchExpr="displayLabel"
                  showSelectionControls={true}
                  selectionMode="multiple"
                  onSelectionChanged={this.dataFieldSelectionChanged}
                  onItemRendered={this.dataFieldRender}
                ></List>}
              closeOnOutsideClick={false}
              className={this.state.selectedItems.length > 0 ? "GridHeightAccordianOpen-tabs" : "GridHeightTabPanel-with-toolbar"}>
              <div>
                <DataGrid
                  onExporting={(e) => { if (window.handleDevExtremeDataGridExport) window.handleDevExtremeDataGridExport(e); }}
                  id="gridContainer"
                  ref={dataGrid}
                  showBorders={true}
                  rowAlternationEnabled={true}
                  allowColumnReordering={true}
                  allowColumnResizing={true}
                  columnAutoWidth={true}
                  className={this.state.selectedItems.length > 0 ? "WMReportGridHeightWithAccordianDouble" : "WMReportGridStyle-AccordianClosed"}
                >
                  <Editing mode="cell" newRowPosition="last" refreshMode="repaint" allowUpdating={true} useIcons={true} />
                  <Column dataField="displayLabel" caption="Display Label" allowEditing={false} />
                  <Column dataField="orderBy" caption="Order By"><Lookup dataSource={orderByDataSource} displayExpr="Text" valueExpr="ID" /></Column>
                  <Column dataField="prefix" caption="Prefix"><Lookup dataSource={prefixDataSource} displayExpr="Text" valueExpr="ID" /></Column>
                  <Column dataField="group" caption="Group"><Lookup dataSource={groupDataSource} displayExpr="Text" valueExpr="ID" /></Column>
                  <Column dataField="operation" caption="Operation"><Lookup dataSource={operationDataSource} displayExpr="Text" valueExpr="ID" /></Column>
                  <Column dataField="from" caption="From" />
                  <Column dataField="to" caption="To" />
                </DataGrid>
              </div>
            </Drawer>
          </div>
        </div>
        {this.state.isPreviewGridPopupVisible &&
          <Popup
            visible={this.state.isPreviewGridPopupVisible}
            onHiding={() => this.setState({ isPreviewGridPopupVisible: false })}
            dragEnabled={false} hideOnOutsideClick={true} showCloseButton={true} showTitle={true}
            title={"Preview"} container=".dx-viewport" closeOnOutsideClick={true} width="80vw" height="78vh"
          >
            <ScrollView>
              <UpdateStageGridPreview dataSource={this.state.previewData} />
            </ScrollView>
          </Popup>
        }
        {this.state.isPrintPreviewPopupVisible &&
          <Popup
            visible={this.state.isPrintPreviewPopupVisible}
            onHiding={() => this.setState({ isPrintPreviewPopupVisible: false })}
            dragEnabled={false} hideOnOutsideClick={true} showCloseButton={true} showTitle={true}
            title={"Print Errors"} container=".dx-viewport" closeOnOutsideClick={true}
          >
            <ScrollView width="100%" height="100%">
              <UpdateStagePrintErrors dataSource={this.state.ABErros} reportname="ABR003" reportformat="Standard Abecas" />
            </ScrollView>
          </Popup>
        }
      </>
    );
  }
}

function mapStateToProps(state) {
  return { ReceiptReducer: state.ReceiptReducer, oidc: state.oidc };
}
export default connect(mapStateToProps)(UpdateTransactionsStage);
